// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ISiteRegistrationData {
    static getAttributeTypeMap() {
        return ISiteRegistrationData.attributeTypeMap;
    }
}
ISiteRegistrationData.discriminator = undefined;
ISiteRegistrationData.attributeTypeMap = [
    {
        "name": "userId",
        "baseName": "userId",
        "type": "number"
    },
    {
        "name": "accountId",
        "baseName": "accountId",
        "type": "number"
    },
    {
        "name": "caseId",
        "baseName": "caseId",
        "type": "number"
    }
];
//# sourceMappingURL=iSiteRegistrationData.js.map